<template>
  <ArtisanGrid
      ref="notes"
      metaKey="ZlNotesInfo"
  >
    <template #leftAside>
      <artisan-group style="height: 100%; border: none; overflow-y: auto">

      </artisan-group>
    </template>
  </ArtisanGrid>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {

  },
  methods: {},
};
</script>
